import SalesCategoriesActions from 'common/redux/actions/salesCategories';
import { SalesCategory } from 'common/models/internal/SalesCategory';
import * as Immutable from 'immutable';

export const salesCategories = (state = Immutable.fromJS({}), action) => {
    const { type, response, params } = action;
    switch (type) {
        case SalesCategoriesActions.SET_IS_FETCHING_SALES_CATEGORIES_IN_PROGRESS: {
            const isFetchingSalesCategoriesInProgress = response;
            const { clientId } = params;
            return state.setIn(
                [clientId, 'isFetchingSalesCategoriesInProgress'],
                isFetchingSalesCategoriesInProgress
            );
        }
        case SalesCategoriesActions.INJECT_SALES_CATEGORIES: {
            const salesCategories = response;
            const salesCategoriesImmutable = Immutable.List().withMutations(
                salesCategoriesImmutable => {
                    salesCategories.forEach(salesCategory => {
                        const { id, name, capacity } = salesCategory;
                        const salesCategoryImmutable = SalesCategory.fromJS({
                            id,
                            name,
                            capacity
                        });
                        salesCategoriesImmutable.push(salesCategoryImmutable);
                    });
                }
            );
            const { clientId } = params;
            return state
                .setIn([clientId, 'salesCategories'], salesCategoriesImmutable)
                .setIn(
                    [clientId, 'isFetchingsalesCategoriesInProgress'],
                    false
                );
        }
        case SalesCategoriesActions.INJECT_OUTLET_SALES_CATEGORIES: {
            const outletSalesCategories = response;
            const outletSalesCategoriesImmutable = outletSalesCategories.map(
                outletSalesCategory => {
                    const { id, name, capacity } = outletSalesCategory;
                    return SalesCategory.fromJS({
                        id,
                        name,
                        capacity
                    });
                }
            );

            const { clientId } = params;
            return state
                .setIn(
                    [clientId, 'outletSalesCategories'],
                    Immutable.List(outletSalesCategoriesImmutable)
                )
                .setIn(
                    [clientId, 'isFetchingsalesCategoriesInProgress'],
                    false
                );
        }
        default:
            return state;
    }
};
